// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input__prepend-inner{margin-top:auto!important;margin-bottom:auto!important}", ""]);
// Exports
module.exports = exports;
